import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { getWhatsAppUrl } from '../utils/whatsapp';
export const CtaBand = () => {
  return <section className="bg-brand-600 py-8" data-id="element-103">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-104">
        <h2 className="text-2xl font-bold text-white mb-3" data-id="element-105">
          ¿Tenés dudas sobre el tratamiento?
        </h2>
        <p className="text-brand-100 text-base mb-6" data-id="element-106">
          Escribinos directo. Estamos para asesorarte y encontrar el plan ideal
          para vos.
        </p>
        <a href={getWhatsAppUrl('Hola! Me gustaría hacerles una consulta sobre los tratamientos.')} target="_blank" rel="noopener noreferrer" data-id="element-107">
          <Button variant="secondary" size="md" className="gap-2 bg-white text-brand-700 hover:bg-slate-50 text-sm sm:text-base" data-id="element-108">
            <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-109" />
            Contáctanos para más información
          </Button>
        </a>
      </div>
    </section>;
};